import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface EventRowHeaderPropsType {
    variant: DefaultComponentVariantType | null;
}

export const EventRowHeader = withConfig(theme => styled('div', { label: 'EventRowHeader' })<EventRowHeaderPropsType>`
    border-right: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'none' : variant === DefaultComponentVariantType.TERTIARY ? 'none' : `1px solid  ${theme.star.eventRow.borderColor}`};
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 auto;
    min-width: 0;
    transition: background-color .2s ease;
`);

export const EventRowMarkets = styled('div', { label: 'EventRowMarkets' })`
    min-width: 100%;
`;

interface EventRowSelectionsPropsType {
    variant: DefaultComponentVariantType | null;
    isExpandedSelectionLayout?: boolean;
}

export const EventRowSelections = withConfig(theme => styled('ul', { label: 'EventRowSelections' })<EventRowSelectionsPropsType>`
    display: flex;
    flex-flow: row nowrap;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    justify-content: center;
    gap: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.gap.small : variant === DefaultComponentVariantType.TERTIARY ? theme.star.gap.small : '0'};
    ${({ variant, isExpandedSelectionLayout = false }): SerializedStyles =>
        variant === DefaultComponentVariantType.TERTIARY && isExpandedSelectionLayout === true
            ? css`
                  align-self: flex-start;
                  flex: 0 0 auto;
                  justify-content: flex-end;
                  margin-left: ${theme.star.gap.small};

                  & > li {
                      flex: 0 0 65px;
                      width: 65px;
                      min-width: 65px;
                      height: auto;
                  }

                  @media ${theme.star.mediaQuery.tablet} {
                      & > li {
                          flex: 0 0 185px;
                          width: 185px;
                          min-width: 185px;
                          max-width: 185px;
                      }
                  }
              `
            : css``}
`);

export const EventRowSelectionsElement = styled('li', { label: 'EventRowSelectionsElement' })`
    display: flex;
    height: 100%;
`;

const setEventRowMetaTime = (variant: DefaultComponentVariantType | null, theme: EmotionTheme):SerializedStyles => {
  if (variant === DefaultComponentVariantType.TERTIARY) {
    return css`
        flex: 1;
        justify-content: space-between;

        & [class$='BabIconWrapper'] {
            margin: 0;
            fill: ${theme.star.unified.score.color.txtPrimary};
        }
    `;
  }

  return css`
      font-size: ${theme.star.fontSize.xSmall};
      line-height: ${theme.star.lineHeight[250]};
  `;
}

export const EventRowMetaTime = withConfig(theme => styled('span', { label: 'EventRowMetaTime' })<{variant?: DefaultComponentVariantType | null}>`
    display: flex;
    align-content: center;
    font-weight: ${theme.star.fontWeight.regular};
    ${({ variant = null }):SerializedStyles => setEventRowMetaTime(variant, theme)};
`);

export const CompetitionWrapper = withConfig(theme => styled('div', { label: 'CompetitionWrapper' })`
    display: flex;
    flex-flow: column nowrap;
    gap: ${theme.star.gap.small};
`);


export const EventRowSelectionWithLine = withConfig(theme => styled('div', { label: 'EventRowSelectionWithLine' })`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-end;
    gap: ${theme.star.gap.xSmall};
`);

export const EventRowSelectionLine = withConfig(theme => styled('span', { label: 'EventRowSelectionLine' })`
    color: ${theme.star.unified.eventRow.txtColorSecondary};
    font-size: ${theme.star.fontSize.xSmall};
    font-weight: ${theme.star.fontWeight.regular};
`);

export const EventRowParticipantsAndScore = styled('div', { label: 'EventRowParticipantsAndScore' })`
    display: flex;
    align-items: space-between;
    gap: 10px;
    width: 100%;
`;

export const EventRowParticipants = styled('div', { label: 'EventRowParticipants' })`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 4px;
`;
